import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import auth from './auth.module'
import user from './user.module'
import weekDay from './week-day.module'
import bm from './bm.module'
import banner from './banner.module'
import cashFlow from "./cash-flow.module";
import invoice from "./invoice.module";
import services from './services.module'
import profile from './profile.module'
import persons from './persons.module'
import schedule from './schedule.module'
import product from './product.module'
import supplier from './supplier.module'
import social from './social.module'
import checkout from "./checkout.module";
import charge from "./charge.module";
import financial from "./financial.module";
import menu from './menu.module'

import {CHANGE_PROGRESS, CHRANGE_SNACK} from './mutations/mutations.type'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        inProgress: false,
        snackbar: {
            timeout: 9000,
            color: '',
            snackbar: false,
            text: ''
        },
        confirmDialog: {
            dialog: false,
            title: '',
            text: '',
            evento: () => {
            }
        },
        colors:{
            red:"#FF3816",
            orange:"#ff8c00",
            green:"success"
        }
    },
    getters: {
        inProgress: state => {
            return state.inProgress
        },
        snackbar: state => {
            return state.snackbar
        },
        confirmDialog: state => {
            return state.confirmDialog
        }
    },
    mutations: {
        [CHANGE_PROGRESS](state, opt) {
            state.inProgress = opt
        },
        [CHRANGE_SNACK](state, snack) {
            state.snackbar = snack
        }
    },
    modules: {
        auth,
        user,
        bm,
        banner,
        services,
        cashFlow,
        invoice,
        weekDay,
        profile,
        persons,
        product,
        supplier,
        social,
        schedule,
        checkout,
        charge,
        financial,
        menu
    },
    plugins: [
        createPersistedState({
            paths: [
                'auth',
                'cashFlow',
                'invoice',
                'checkout',
                'financial'
            ]
        })
    ]
})
